import React from 'react';
import { useTranslation } from 'react-i18next';

import { Message } from '@/components/shared/Message';

import * as styles from './index.module.scss';

type Props = {
  children?: never;
  setVisible: (value: boolean) => void;
  email: string;
};

export const InvitedMessage: React.FC<Props> = (props) => {
  const { setVisible, email } = props;
  const { t } = useTranslation();

  return (
    <Message colorType="info" setVisible={setVisible} className={styles.root}>
      <p className={styles.paragraph}>
        {t('text.membership.invite.doneWithUnactivated', {
          email,
        })}
      </p>
    </Message>
  );
};
